// Lucide icon: search (https://lucide.dev/icons/search)
import { Search } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconSearch = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Search />
    </IconComponentStyled>
  )
}
